var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    style: {
      height: 200
    },
    width: 413,
    height: 413,
    viewBox: "0 0 413 413",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 220.2C55 264.014 72.4049 306.033 103.386 337.014C134.367 367.995 176.386 385.4 220.2 385.4C264.014 385.4 306.033 367.995 337.014 337.014C367.995 306.033 385.4 264.014 385.4 220.2C385.4 176.386 367.995 134.367 337.014 103.386C306.033 72.4049 264.014 55 220.2 55C176.386 55 134.367 72.4049 103.386 103.386C72.4049 134.367 55 176.386 55 220.2Z",
    fill: "#D9EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.558 337.544C146.558 339.434 152.69 341.246 163.605 342.582C174.521 343.918 189.325 344.669 204.762 344.669C220.198 344.669 235.003 343.918 245.918 342.582C256.834 341.246 262.966 339.434 262.966 337.544C262.966 335.655 256.834 333.843 245.918 332.507C235.003 331.171 220.198 330.42 204.762 330.42C189.325 330.42 174.521 331.171 163.605 332.507C152.69 333.843 146.558 335.655 146.558 337.544Z",
    fill: "#B0D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.041 223.321L132.61 236.363L137.335 302.245C138.261 301.628 138.961 300.726 139.33 299.676L162.202 226.881C162.568 225.712 162.511 224.452 162.041 223.321Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.611 236.363L162.041 223.321V223.288C161.561 222.16 160.698 221.238 159.604 220.686L134.944 208.218C133.574 207.525 132.068 207.144 130.533 207.102L132.631 236.372L132.611 236.363Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.508 207.095C128.96 207.053 127.423 207.356 126.007 207.983L99.5747 219.687L132.59 236.364L130.508 207.095Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5951 219.687L89.7739 255.346L132.61 236.364L99.5951 219.687Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7739 255.346L135.406 303.101C135.761 303.067 136.112 302.995 136.451 302.887C136.76 302.707 137.049 302.495 137.314 302.255L132.61 236.365L89.7739 255.346Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3428 268.388L89.7732 255.346L135.406 303.101C134.325 303.375 133.185 303.288 132.159 302.853L62.8745 270.9C61.7618 270.386 60.8655 269.497 60.3428 268.388Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7735 255.345L60.3431 268.388V268.35C59.8282 267.239 59.7243 265.98 60.0499 264.799L67.3765 238.156C67.7861 236.676 68.5165 235.304 69.5158 234.138L89.79 255.353L89.7735 255.345Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4995 234.13C70.5099 232.956 71.7681 232.021 73.1835 231.392L99.6155 219.687L89.7943 255.346L69.4995 234.13Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.692 237.888L269.119 250.927L264.398 316.808C263.473 316.191 262.774 315.29 262.407 314.24L239.54 241.444C239.167 240.278 239.221 239.018 239.692 237.888Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M269.12 250.922L239.693 237.887V237.854C240.173 236.727 241.036 235.805 242.13 235.252L266.79 222.78C268.163 222.091 269.67 221.711 271.205 221.665L269.103 250.934L269.12 250.922Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M271.217 221.657C272.766 221.615 274.306 221.918 275.723 222.545L302.155 234.25L269.14 250.923L271.217 221.657Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.134 234.25L311.96 269.908L269.119 250.923L302.134 234.25Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M311.959 269.908L266.323 317.663C265.969 317.627 265.621 317.555 265.282 317.448C264.974 317.271 264.686 317.06 264.423 316.821L269.143 250.935L311.959 269.908Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M341.385 282.947L311.959 269.908L266.322 317.664C267.401 317.937 268.54 317.85 269.564 317.416L338.857 285.458C339.971 284.947 340.867 284.057 341.385 282.947Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.96 269.908L341.386 282.946V282.913C341.898 281.8 342 280.542 341.675 279.361L334.349 252.714C333.941 251.235 333.21 249.864 332.21 248.7L311.939 269.916L311.96 269.908Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.229 248.692C331.221 247.517 329.964 246.582 328.549 245.954L302.117 234.25L311.942 269.908L332.229 248.692Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M106.881 105.261L120.737 100.64C120.999 100.556 121.228 100.39 121.391 100.168C121.553 99.9448 121.641 99.6763 121.641 99.4006C121.641 99.1249 121.553 98.8563 121.391 98.6336C121.228 98.4109 120.999 98.2456 120.737 98.1616L109.35 94.3661C108.581 94.1102 107.881 93.6783 107.308 93.1048C106.734 92.5312 106.302 91.8318 106.046 91.0621L102.259 79.7087C102.177 79.444 102.013 79.2125 101.79 79.048C101.567 78.8836 101.297 78.7948 101.02 78.7948C100.743 78.7948 100.473 78.8836 100.25 79.048C100.027 79.2125 99.8629 79.444 99.7811 79.7087L95.9856 91.0951C95.73 91.865 95.2982 92.5645 94.7246 93.1381C94.151 93.7117 93.4515 94.1435 92.6816 94.3992L81.287 98.1988C81.0222 98.2806 80.7907 98.445 80.6262 98.668C80.4618 98.8909 80.373 99.1607 80.373 99.4377C80.373 99.7148 80.4618 99.9846 80.6262 100.208C80.7907 100.431 81.0222 100.595 81.287 100.677L92.6816 104.476C93.4515 104.732 94.151 105.164 94.7246 105.737C95.2982 106.311 95.73 107.011 95.9856 107.78L99.7852 119.179C99.8693 119.442 100.035 119.671 100.257 119.833C100.48 119.996 100.749 120.083 101.024 120.083C101.3 120.083 101.568 119.996 101.791 119.833C102.014 119.671 102.179 119.442 102.263 119.179L106.881 105.261Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M358.695 152.426L372.551 147.805C372.814 147.721 373.043 147.556 373.205 147.333C373.368 147.11 373.455 146.842 373.455 146.566C373.455 146.29 373.368 146.022 373.205 145.799C373.043 145.576 372.814 145.411 372.551 145.327L361.165 141.531C360.395 141.276 359.696 140.844 359.122 140.27C358.548 139.697 358.117 138.997 357.861 138.227L354.065 126.841C353.981 126.578 353.816 126.349 353.593 126.187C353.37 126.024 353.102 125.937 352.826 125.937C352.55 125.937 352.282 126.024 352.059 126.187C351.836 126.349 351.671 126.578 351.587 126.841L347.792 138.227C347.535 138.997 347.103 139.696 346.53 140.27C345.956 140.843 345.257 141.275 344.488 141.531L333.089 145.327C332.826 145.411 332.597 145.576 332.435 145.799C332.272 146.022 332.185 146.29 332.185 146.566C332.185 146.842 332.272 147.11 332.435 147.333C332.597 147.556 332.826 147.721 333.089 147.805L344.488 151.6C345.258 151.855 345.958 152.287 346.531 152.861C347.105 153.434 347.537 154.134 347.792 154.904L351.591 166.299C351.675 166.562 351.841 166.791 352.063 166.953C352.286 167.116 352.555 167.203 352.83 167.203C353.106 167.203 353.375 167.116 353.597 166.953C353.82 166.791 353.985 166.562 354.069 166.299L358.695 152.426Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M273.997 75.2399C274.436 73.3396 275.399 71.6006 276.778 70.2212C278.156 68.8418 279.895 67.8776 281.795 67.4383L297.452 63.8287C297.738 63.761 297.992 63.5988 298.175 63.3683C298.357 63.1378 298.456 62.8526 298.456 62.5587C298.456 62.2649 298.357 61.9796 298.175 61.7492C297.992 61.5187 297.738 61.3565 297.452 61.2888L281.795 57.6791C279.894 57.2417 278.154 56.278 276.776 54.8984C275.397 53.5187 274.434 51.7787 273.997 49.8776L270.384 34.2331C270.318 33.9462 270.156 33.6901 269.926 33.5067C269.696 33.3234 269.41 33.2235 269.116 33.2235C268.821 33.2235 268.536 33.3234 268.305 33.5067C268.075 33.6901 267.914 33.9462 267.848 34.2331L264.238 49.8776C263.8 51.779 262.836 53.519 261.457 54.8991C260.077 56.2792 258.338 57.244 256.437 57.6833L240.78 61.2888C240.494 61.3565 240.239 61.5187 240.057 61.7492C239.875 61.9796 239.775 62.2649 239.775 62.5587C239.775 62.8526 239.875 63.1378 240.057 63.3683C240.239 63.5988 240.494 63.761 240.78 63.8287L256.424 67.4383C258.325 67.8773 260.064 68.8414 261.443 70.2208C262.823 71.6001 263.787 73.3392 264.226 75.2399L267.835 90.8967C267.901 91.1837 268.063 91.4397 268.293 91.6231C268.523 91.8065 268.809 91.9063 269.103 91.9063C269.398 91.9063 269.683 91.8065 269.914 91.6231C270.144 91.4397 270.305 91.1837 270.371 90.8967L273.997 75.2399Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.47 181.865L257.517 177.615L209.725 284.623C211.69 284.433 213.54 283.608 214.995 282.273L311.74 187.572C313.294 186.05 314.26 184.029 314.47 181.865Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.518 177.615L314.47 181.864V181.786C314.661 179.617 314.075 177.451 312.818 175.673L284.693 135.517C283.133 133.296 281.104 131.445 278.75 130.095L257.518 177.631V177.615Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.751 130.095C276.364 128.73 273.703 127.916 270.962 127.712L219.849 123.9L257.518 177.631L278.751 130.095Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M219.848 123.884L174.62 171.428L257.517 177.615L219.848 123.884Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M174.62 171.428L206.008 284.342C206.592 284.584 207.2 284.763 207.821 284.879H207.846H207.867C208.497 284.856 209.124 284.769 209.738 284.618L257.53 177.61L174.62 171.428Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.668 167.179L174.621 171.429L206.009 284.343C204.089 283.874 202.376 282.789 201.131 281.254L119.522 173.225C118.209 171.492 117.552 169.35 117.668 167.179Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.62 171.428L117.667 167.179V167.096C117.802 164.932 118.694 162.885 120.187 161.314L153.966 125.796C155.846 123.825 158.135 122.291 160.673 121.302L174.616 171.465L174.62 171.428Z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M160.678 121.269C163.24 120.275 165.991 119.865 168.731 120.067L219.848 123.9L174.621 171.428L160.678 121.269Z",
    fill: "white",
    stroke: "#020064",
    strokeWidth: 4.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanCompleted);
export default __webpack_public_path__ + "static/media/PlanCompleted.5baa67e0a6e1e3a58e0e290812e4ffd6.svg";
export { ForwardRef as ReactComponent };